"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _button = _interopRequireDefault(require("./components/button"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n\n  z-index: 1;\n  padding: ", ";\n  background: ", ";\n  border-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalFooterBase = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.padding;
}, function (props) {
  return props.theme.palette.white.main;
}, function (props) {
  return props.bordered ? "1px solid ".concat(props.theme.palette.black.lighter) : '';
});

var ModalFooter = function ModalFooter(props) {
  return _react["default"].createElement(ModalFooterBase, (0, _omit["default"])(props, 'children'), props.children);
}; // Compound.


ModalFooter.Button = _button["default"]; // Prop Registration

ModalFooter.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  bordered: _propTypes["default"].bool,
  padding: _propTypes["default"].string
};
ModalFooter.defaultProps = {
  bordered: false,
  padding: '8px'
};
var _default = ModalFooter;
exports["default"] = _default;